import { gql, useQuery } from 'urql';

export const MESSAGES_STATS_QUERY = gql`
  query GetMessagesStats($input: StatsInput!) {
    getMessagesStats(input: $input) {
      isSent
      totalMessages
      smsStats {
        channel
        successCount
        errorCount
        pendingCount
        errorData {
          ... on SmsErrorData {
            ticketId
            firstName
            lastName
            phone
            errorCode
            errorText
            contentType
          }
        }
      }
      emailStats {
        channel
        successCount
        errorCount
        pendingCount
        errorData {
          ... on EmailErrorData {
            ticketId
            firstName
            lastName
            email
            errorCode
            errorText
            contentType
          }
        }
      }
      vkStats {
        channel
        successCount
        errorCount
        pendingCount
        errorData {
          ... on VkErrorData {
            ticketId
            firstName
            lastName
            email
            errorCode
            errorText
            contentType
          }
        }
      }
    }
  }
`;

export type ChannelEnum = 'SMS' | 'EMAIL' | 'VK';
export type ContentTypeEnum = string;
export interface ErrorData {
  firstName?: string;
  lastName?: string;
  phone?: string;
  email?: string;
  errorText: string;
}

export interface ChannelStats {
  channel: ChannelEnum;
  successCount: number;
  errorCount: number;
  pendingCount: number;
  errorData: ErrorData[];
}

export interface MessagesStats {
  isSent: boolean;
  totalMessages: number;
  smsStats: ChannelStats;
  emailStats: ChannelStats;
  vkStats: ChannelStats;
}

export interface GetMessagesStatsVariables {
  input: {
    eventId: number;
    attempt?: number | null;
    channel?: ChannelEnum | null;
    contentType?: ContentTypeEnum | null;
  };
}

export const useFetchMessagesStats = (input?: GetMessagesStatsVariables['input'], pause = false) => {
  const shouldPause = pause || input?.attempt == null;
  const [result, reexecuteQuery] = useQuery({
    query: MESSAGES_STATS_QUERY,
    variables: !shouldPause && input ? { input } : undefined,
    pause: shouldPause,
    requestPolicy: 'network-only',
  });

  return {
    messagesStats: result.data?.getMessagesStats || null,
    fetching: result.fetching,
    error: result.error,
    refetch: () => reexecuteQuery({ requestPolicy: 'network-only' }),
  };
};
